var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('button',{staticClass:"button__clear",on:{"click":_vm.deleteValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }